let isFiltering = false;
/**
 * FILTER THUMBNAILS BASED ON SELECTED VARIANT
 * @param {string} selectedValue
 * @param {HTMLElement} productContainer
 */
function filterThumbnailsByVariant(selectedValue, productContainer) {
  if (!selectedValue  || !productContainer) return;

  const thumbnailList = productContainer.querySelector('media-gallery');
  if (!thumbnailList) return;

  isFiltering = true;

  function normalize(str = '') {
  return str
    .toLowerCase()
    .trim()
    .replace(/\s+/g, ' ');
}

  requestAnimationFrame(() => {
    const items = thumbnailList.querySelectorAll('li.slider__slide img');
    let firstMatch = null;

    items.forEach(item => {
    //  const alt = normalize(item.alt);
    const alt = normalize(item.alt.split('|', 1)[0]);

    const selected = normalize(selectedValue);
     const selectedWithVariant = selected + '-v';
     
      console.log("alt:" , alt);
       const slide = item.closest('li.slider__slide');
      if (alt == selected || alt.includes(selectedWithVariant)) {
       
        slide.hidden = false;
        if (!firstMatch) firstMatch = item;
      } else {
        slide.hidden = true;
      }
      
    });

    if (firstMatch) {
      firstMatch.querySelector('button')?.click();
      firstMatch.scrollIntoView({
        behavior: 'auto',
        inline: 'start',
        block: 'nearest'
      });
    }

const sliderComponent = getSliderComponentFromThumbnail(thumbnailList);


if (sliderComponent) {
  const slider = sliderComponent.querySelector('.slider');
  const slides = slider.querySelectorAll('.slider__slide:not([hidden])');

  slider.style.scrollBehavior = 'auto';
  slider.scrollLeft = 0;
  slider.offsetHeight;

  sliderComponent.initPages?.();
  sliderComponent.update?.();

  const prevButton = sliderComponent.querySelector('.slider-button--prev');
  const nextButton = sliderComponent.querySelector('.slider-button--next');

  prevButton?.removeAttribute('disabled');

  if (slides.length <= 3) {
    nextButton?.setAttribute('disabled', 'disabled');
  } else {
    nextButton?.removeAttribute('disabled');
  }

  requestAnimationFrame(() => {
    slider.style.scrollBehavior = '';
    sliderComponent.toggleButtons?.();
  });
}

    isFiltering = false;
  });
}
function getSliderComponentFromThumbnail(el) {
  const slider =
    el.closest('.thumbnail-list.slider') ||
    el.querySelector?.('.thumbnail-list.slider');

  return slider?.closest('slider-component') || null;
}


/**
 * VARIANT CHANGE — MAIN PRODUCT ONLY
 */
document.addEventListener('change', function (event) {

  const mainVariantSelects = event.target.closest(
    'variant-selects[id$="__main"]'
  );
  if (!mainVariantSelects) return;

  const productContainer = mainVariantSelects.closest('.product');
  if (!productContainer) return;

  if (!event.target.matches('input[type="radio"], select')) return;

  const selectedValue = event.target.value?.toLowerCase().trim();
  filterThumbnailsByVariant(selectedValue, productContainer);
});



document.addEventListener('DOMContentLoaded', () => {
  const mainVariantSelects = document.querySelector(
    'variant-selects[id$="__main"]'
  );
  if (!mainVariantSelects) return;

  const productContainer = mainVariantSelects.closest('.product');
  if (!productContainer) return;

  const checkedVariant = mainVariantSelects.querySelector(
    'input[type="radio"]:checked'
  );
  // console.log(checkedVariant,"checkedVariant...");

  if (checkedVariant) {
    filterThumbnailsByVariant(
      checkedVariant.value.toLowerCase().trim(),
      productContainer
    );
  }
});



(function () {
  let loading = false;
  let observer;

  function initInfiniteScroll() {
    const grid = document.querySelector('#product-grid');
    const wrapper = document.querySelector('.load-more[data-infinite="true"]');

    if (!grid || !wrapper) return;

    if (observer) observer.disconnect();

    observer = new IntersectionObserver(async (entries) => {
      if (!entries[0].isIntersecting || loading) return;

      const nextUrl = grid.dataset.nextUrl;
      if (!nextUrl) {
        observer.disconnect();
        wrapper.remove();
        return;
      }

      loading = true;
      wrapper.classList.add('is-loading');

      try {
        const response = await fetch(nextUrl);
        const html = await response.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');

        const newGrid = doc.querySelector('#product-grid');
        if (!newGrid) throw new Error('No product grid found');

        const newItems = newGrid.querySelectorAll('li');
        newItems.forEach(item => grid.appendChild(item));

        const newNextUrl = newGrid.dataset.nextUrl;
        if (newNextUrl) {
          grid.dataset.nextUrl = newNextUrl;
        } else {
          observer.disconnect();
          wrapper.remove();
        }

      } catch (err) {
        console.error('Infinite scroll error:', err);
      }

      wrapper.classList.remove('is-loading');
      loading = false;

    }, {
      rootMargin: '400px'
    });

    observer.observe(wrapper);
  }

  document.addEventListener('DOMContentLoaded', initInfiniteScroll);
  document.addEventListener('shopify:section:load', initInfiniteScroll);
})();
